import { packList } from "@/mocks/gossip";

export default function Pack() {
  return (
    <section id="pack" className="scroll-mt-20 bg-[#FFF9F1]">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-extrabold text-stone-900 md:text-2xl">
              热门打包合集<i className="ri-stack-line text-emerald-600"></i>
            </h2>
            <p className="mt-1.5 text-sm text-stone-600">把一个大事件的多条线索收进同一页，多瓜连吃不用来回跳转。</p>
          </div>
          <span className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-emerald-100 px-3 py-1 text-xs font-medium text-emerald-800">
            <i className="ri-archive-line"></i>持续扩充中
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
          {packList.map((p, idx) => (
            <article
              key={idx}
              className="group flex flex-col rounded-xl border border-stone-200/80 bg-white p-5 transition-colors hover:border-emerald-300"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1 rounded-md bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-700">
                  <i className="ri-stack-line"></i>
                  {p.tag}
                </span>
                <span className="text-xs text-stone-400">{p.count}</span>
              </div>

              <h3 className="mt-4 text-[15px] font-bold leading-snug text-stone-900 group-hover:text-emerald-700 md:text-base">
                {p.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">{p.desc}</p>

              <div className="mt-4 flex items-center justify-between border-t border-stone-200/70 pt-3">
                <span className="flex min-w-0 items-center gap-1.5 text-xs text-stone-400">
                  <i className="shrink-0 ri-link"></i>
                  <span className="truncate">{p.from}</span>
                </span>
                <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-emerald-700">
                  打开合集
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}